import { requireAuth } from '@/features/auth/guards/require-auth'
import { GoodsReceiptsListPage } from '@/features/goods-receipts/pages/goods-receipts-list-page'
import { goodsReceiptsListQuery } from '@/features/goods-receipts/queries/goods-receipt-queries'
import { projectsListQuery } from '@/features/projects/queries/projects-query'
import { usersListQuery } from '@/features/references/users/users-query'
import { messages } from '@/lib/i18n/messages'
import { createFileRoute, redirect } from '@tanstack/react-router'
import * as z from 'zod'

const SearchSchema = z.object({
  project: z.coerce.number().int().positive().optional(),
})

export const Route = createFileRoute('/_app/goods-receipts/')({
  validateSearch: SearchSchema,
  beforeLoad: async (params) => {
    const ctx = await requireAuth(params)
    if (!ctx.user.is_staff) {
      throw redirect({ to: '/projects/' })
    }
    return ctx
  },
  loader: ({ context: { queryClient } }) =>
    Promise.all([
      queryClient.ensureQueryData(goodsReceiptsListQuery()),
      queryClient.ensureQueryData(projectsListQuery()),
      queryClient.ensureQueryData(usersListQuery()),
    ]),
  component: GoodsReceiptsListPage,
  staticData: { crumb: messages.crumbs.goodsReceipts },
})
